import { ExpansionPanel, ExpansionPanelSummary, Grid } from '@material-ui/core';
import { Field } from 'redux-form';
import { TextField } from 'iqvia-shared/components';
import React from 'react';

import { checkLength, checkRequired } from '../../../../Shared/Forms/FormValidation';
import { uniquePathNameValidator } from './validators';
import PathStatus from './PathStatus';

export const pathRemainingStyles = {
  name: {
    '& input': {
      borderColor: '#fff',
      '&:focus': {
        borderColor: '#1f6afc',
      },
    },
    '& > div': {
      margin: 0,
    },
  },
};

const RemainingPathComponent = ({
  classes,
  intl,
  item,
  index,
  renamePathDispatch,
  readonlyForm,
}) => {
  const handleNameChange = value => renamePathDispatch(index, value);

  return (
    <React.Fragment>
      <ExpansionPanel expanded={false}>
        <ExpansionPanelSummary>
          <Grid container spacing={8}>
            <Grid item xs={5} className={classes.name}>
              <Field
                name={item.arguments.branchResult}
                disabled={readonlyForm}
                component={TextField}
                onChange={(_, value) => handleNameChange(value)}
                validate={[checkRequired, uniquePathNameValidator, value => checkLength(value, 50)]}
              />
            </Grid>
            <Grid item xs={7}>
              <PathStatus
                hint={intl.formatMessage({
                  id: 'journeyBuilder.decisionSplit_remainingHint',
                })}
              />
            </Grid>
          </Grid>
        </ExpansionPanelSummary>
      </ExpansionPanel>
    </React.Fragment>
  );
};

RemainingPathComponent.displayName = 'RemainingPathComponent';

export default RemainingPathComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/RemainingPathComponent.js